enum ROUTES {
  AUTH_LOGIN = 'AUTH_LOGIN',
  AUTH_HOME = 'AUTH_HOME',
  // PORTAL ROUTE ENTRY
  PORTAL_INVENTORY_COUNT = 'PORTAL_INVENTORY_COUNT',
  PORTAL_CREATE_SITE = 'PORTAL_CREATE_SITE',
  PORTAL_SITE_DETAILS = 'PORTAL_SITE_DETAILS',
  PORTAL_TRANSFERS = 'PORTAL_TRANSFERS',
  PORTAL_IMPACT_REPORT = 'PORTAL_IMPACT_REPORT',
  PORTAL_HARVEST_SUMMARY = 'PORTAL_HARVEST_SUMMARY',
  PORTAL_GROUPS = 'PORTAL_GROUPS',
  PORTAL_CASES = 'PORTAL_CASES',
  PORTAL_SCAN_DETAILS = 'PORTAL_SCAN_DETAILS',
  PORTAL_NOT_FOUND = 'PORTAL_NOT_FOUND',
  PORTAL_HISTORY = 'PORTAL_HISTORY',
  PORTAL_EMPLOYEES = 'PORTAL_EMPLOYEES',
  PORTAL_CUSTOMER_CONTACTS = 'PORTAL_CUSTOMER_CONTACTS',
  PORTAL_CUSTOMERS = 'PORTAL_CUSTOMERS',
  PORTAL_SCANS_TYPES = 'PORTAL_SCANS_TYPES',
  PORTAL_SCANS = 'PORTAL_SCANS',
  PORTAL_PACKAGES_CREATED = 'PORTAL_PACKAGES_CREATED',
  PORTAL_ITEMS = 'PORTAL_ITEMS',
  PORTAL_UNIT_TRACKING = 'PORTAL_UNIT_TRACKING',
  PORTAL_ITEMS_SUMMARY = 'PORTAL_ITEMS_SUMMARY',
  PORTAL_SKU = 'PORTAL_SKU',
  PORTAL_COLLECTION_POINTS = 'PORTAL_COLLECTION_POINTS',
  PORTAL_CUSTOMER_SITES = 'PORTAL_CUSTOMER_SITES',
  PORTAL_PICKUPS = 'PORTAL_PICKUPS',
  PORTAL_DELIVERIES = 'PORTAL_DELIVERIES',
  PORTAL_ORDERS = 'PORTAL_ORDERS',
  PORTAL_ORDERS_SUMMARY = 'PORTAL_ORDERS_SUMMARY',
  PORTAL_PURCHASE_ORDERS = 'PORTAL_PURCHASE_ORDERS',
  PORTAL_OPEN_ITEMS = 'PORTAL_OPEN_ITEMS',
  PORTAL_WASH_HUB_DETAILS = 'PORTAL_WASH_HUB_DETAILS',
  PORTAL_PEOPLE = 'PORTAL_PEOPLE',
  PORTAL_LOCATION = 'PORTAL_LOCATION',
  PORTAL_SESSION_HISTORY = 'PORTAL_SESSION_HISTORY',
  PORTAL_STATUSES = 'PORTAL_STATUSES',
  PORTAL_CUP_INVENTORY = 'PORTAL_CUP_INVENTORY',
  PORTAL_WASH_HUB = 'PORTAL_WASH_HUB',
  PORTAL_VENUE_MANAGEMENT = 'PORTAL_VENUE_MANAGEMENT',
  PORTAL_CUP_LIFE_MANAGEMENT = 'PORTAL_CUP_LIFE_MANAGEMENT',
  PORTAL_INVENTORY_TRACKING = 'PORTAL_INVENTORY_TRACKING',
  PORTAL_WAREHOUSE_MANAGEMENT = 'PORTAL_WAREHOUSE_MANAGEMENT',
  PORTAL_DASHBOARD = 'PORTAL_DASHBOARD',
  DASHBOARD = 'DASHBOARD',
  PORTAL_REQUESTS = 'PORTAL_REQUESTS',
  PORTAL_QA_LOG = 'PORTAL_QA_LOG',
  PORTAL_WASHUB_INVENTORY = 'PORTAL_WASHUB_INVENTORY',
  PORTAL_MANUFACTURERS = 'PORTAL_MANUFACTURERS',
  PORTAL_WORKERS = 'PORTAL_WORKERS',
  CMS_SITE_PORTAL = 'CMS_SITE_PORTAL',
  CMS_SITE_ORDER = 'CMS_SITE_ORDER',
  QR_REDIRECT = 'QR_REDIRECT',
  QR_REDIRECT_HOST = 'QR_REDIRECT_HOST',
}

export const routesSettings = Object.freeze({
  // AUTH ROUTE SETTINGS ENTRY

  [ROUTES.AUTH_LOGIN]: {
    name: 'Login',
    path: '/login',
    getPath: () => `/login`,
  },
  // PORTAL ROUTE SETTINGS ENTRY
  [ROUTES.PORTAL_INVENTORY_COUNT]: {
    name: 'InventoryCount',
    path: '/inventory-count',
    getPath: () => '/inventory-count',
  },
  [ROUTES.PORTAL_CREATE_SITE]: {
    name: 'CreateSite',
    path: '/customer-sites/create',
    getPath: () => `/customer-sites/create`,
  },
  [ROUTES.PORTAL_SITE_DETAILS]: {
    name: 'SiteDetails',
    path: '/customer-sites/:id',
    getPath: (_id: string) => `/customer-sites/${_id}`,
  },
  [ROUTES.PORTAL_TRANSFERS]: {
    name: 'Transfers',
    path: '/transfers',
    getPath: () => `/transfers`,
  },
  [ROUTES.PORTAL_IMPACT_REPORT]: {
    name: 'ImpactReport',
    path: '/impact-report',
    getPath: () => `/impact-report`,
  },
  [ROUTES.PORTAL_HARVEST_SUMMARY]: {
    name: 'HarvestSummary',
    path: '/harvest-summary',
    getPath: () => `/harvest-summary`,
  },
  [ROUTES.PORTAL_GROUPS]: {
    name: 'Groups',
    path: '/groups',
    getPath: () => `/groups`,
  },
  [ROUTES.PORTAL_CASES]: {
    name: 'Cases',
    path: '/cases',
    getPath: () => `/cases`,
  },
  [ROUTES.PORTAL_SCAN_DETAILS]: {
    name: 'ScanDetails',
    path: '/scans/:id',
    getPath: () => `/scans/:id`,
  },
  [ROUTES.PORTAL_NOT_FOUND]: {
    name: 'NotFound',
    path: '/*',
    getPath: () => `/*`,
  },
  [ROUTES.PORTAL_HISTORY]: {
    name: 'History',
    path: '/history',
    getPath: () => `/history`,
  },
  [ROUTES.PORTAL_EMPLOYEES]: {
    name: 'Employees',
    path: '/employees',
    getPath: () => `/employees`,
  },
  [ROUTES.PORTAL_CUSTOMER_CONTACTS]: {
    name: 'CustomerContacts',
    path: '/customer-contacts',
    getPath: () => `/customer-contacts`,
  },
  [ROUTES.PORTAL_CUSTOMERS]: {
    name: 'Customers',
    path: '/customers',
    getPath: () => `/customers`,
  },
  [ROUTES.PORTAL_SCANS_TYPES]: {
    name: 'Scans Types',
    path: '/scans-types',
    getPath: () => `/scans-types`,
  },
  [ROUTES.PORTAL_SCANS]: {
    name: 'Scans',
    path: '/scans',
    getPath: () => `/scans`,
  },
  [ROUTES.PORTAL_PACKAGES_CREATED]: {
    name: 'PackagesCreated',
    path: '/packages-created',
    getPath: () => `/packages-created`,
  },
  [ROUTES.PORTAL_ITEMS]: {
    name: 'Items',
    path: '/items',
    getPath: () => `/items`,
  },
  [ROUTES.PORTAL_UNIT_TRACKING]: {
    name: 'Unit Tracking',
    path: '/unit-tracking',
    getPath: () => `/unit-tracking`,
  },
  [ROUTES.PORTAL_ITEMS_SUMMARY]: {
    name: 'Inventory Summary',
    path: '/inventory-summary',
    getPath: () => `/inventory-summary`,
  },
  [ROUTES.PORTAL_SKU]: {
    name: 'Sku',
    path: '/sku',
    getPath: () => `/sku`,
  },
  [ROUTES.PORTAL_COLLECTION_POINTS]: {
    name: 'CollectionPoints',
    path: '/collection-points',
    getPath: () => `/collection-points`,
  },
  [ROUTES.PORTAL_CUSTOMER_SITES]: {
    name: 'CustomerSites',
    path: '/customer-sites',
    getPath: () => `/customer-sites`,
  },
  [ROUTES.PORTAL_PICKUPS]: {
    name: 'Pickups',
    path: '/pickups',
    getPath: () => `/pickups`,
  },
  [ROUTES.PORTAL_DELIVERIES]: {
    name: 'Deliveries',
    path: '/deliveries',
    getPath: () => `/deliveries`,
  },
  [ROUTES.PORTAL_ORDERS]: {
    name: 'Orders',
    path: '/orders',
    getPath: () => `/orders`,
  },
  [ROUTES.PORTAL_ORDERS_SUMMARY]: {
    name: 'Orders Summary',
    path: '/orders-summary',
    getPath: () => `/orders-summary`,
  },
  [ROUTES.PORTAL_PURCHASE_ORDERS]: {
    name: 'PurchaseOrders',
    path: '/purchase-orders',
    getPath: () => `/purchase-orders`,
  },
  [ROUTES.PORTAL_OPEN_ITEMS]: {
    name: 'OpenItems',
    path: '/open-items',
    getPath: () => `/open-items`,
  },
  [ROUTES.PORTAL_WASH_HUB_DETAILS]: {
    name: 'WashHubDetails',
    path: '/wash-hub/:id',
    getPath: () => `/wash-hub/:id`,
  },
  [ROUTES.PORTAL_PEOPLE]: {
    name: 'People',
    path: '/people',
    getPath: () => `/people`,
  },
  [ROUTES.PORTAL_LOCATION]: {
    name: 'Location',
    path: '/location',
    getPath: () => `/location`,
  },
  [ROUTES.PORTAL_SESSION_HISTORY]: {
    name: 'SessionHistory',
    path: '/sessions-history',
    getPath: () => `/sessions-history`,
  },
  [ROUTES.PORTAL_STATUSES]: {
    name: 'Statuses',
    path: '/cup-statuses',
    getPath: () => `/cup-statuses`,
  },
  [ROUTES.PORTAL_CUP_INVENTORY]: {
    name: 'CupInventory',
    path: '/cup-inventory',
    getPath: () => `/cup-inventory`,
  },
  [ROUTES.PORTAL_WASH_HUB]: {
    name: 'WashHub',
    path: '/wash-hub',
    getPath: () => `/wash-hub`,
  },
  [ROUTES.PORTAL_VENUE_MANAGEMENT]: {
    name: 'VenueManagement',
    path: '/venue-management',
    getPath: () => `/venue-management`,
  },
  [ROUTES.PORTAL_CUP_LIFE_MANAGEMENT]: {
    name: 'CupLifeManagement',
    path: '/cup-life-management',
    getPath: () => `/cup-life-management`,
  },
  [ROUTES.PORTAL_INVENTORY_TRACKING]: {
    name: 'InventoryTracking',
    path: '/inventory-tracking',
    getPath: () => `/inventory-tracking`,
  },
  [ROUTES.PORTAL_WAREHOUSE_MANAGEMENT]: {
    name: 'WarehouseManagement',
    path: '/warehouse-management',
    getPath: () => `/warehouse-management`,
  },
  [ROUTES.PORTAL_DASHBOARD]: {
    name: 'Dashboard',
    path: '/dashboard',
    getPath: () => `/dashboard`,
  },
  [ROUTES.PORTAL_REQUESTS]: {
    name: 'Requests',
    path: '/requests',
    getPath: () => `/requests`,
  },
  [ROUTES.PORTAL_QA_LOG]: {
    name: 'QA Log',
    path: '/qa-log',
    getPath: () => `/qa-log`,
  },
  [ROUTES.PORTAL_WASHUB_INVENTORY]: {
    name: 'WashhubInventory',
    path: '/washhub-inventory',
    getPath: () => `/washhub-inventory`,
  },
  [ROUTES.PORTAL_MANUFACTURERS]: {
    name: 'Manufacturers',
    path: '/manufacturers',
    getPath: () => `/manufacturers`,
  },
  [ROUTES.PORTAL_WORKERS]: {
    name: 'Workers',
    path: '/workers',
    getPath: () => `/workers`,
  },
  [ROUTES.CMS_SITE_PORTAL]: {
    name: 'CmsSitePortal',
    path: '/cms/:portalName',
    getPath: () => `/cms/:portalName`,
  },
  [ROUTES.CMS_SITE_ORDER]: {
    name: 'SiteOrder',
    path: '/cms/:portalId/:orderId',
    getPath: () => `/cms/:portalId/:orderId`,
  },
  [ROUTES.QR_REDIRECT]: {
    name: 'QrRedirect',
    path: '/qr/:code',
    getPath: (code: string) => `/qr/${code}`,
  },
  [ROUTES.QR_REDIRECT_HOST]: {
    name: 'QrRedirectHost',
    path: '/:code',
    getPath: (code: string) => `/${code}`,
  },
});

export default ROUTES;
